export default {
    path: '/appraise',
    meta: {
        title: '评价',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/appraise`),
}


// WEBPACK FOOTER //
// ./src/views/Appraise/router.js